import { render, staticRenderFns } from "./LiquidationSeller.vue?vue&type=template&id=b1b4ccf4&"
import script from "./LiquidationSeller.vue?vue&type=script&lang=js&"
export * from "./LiquidationSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports